import { motion, AnimatePresence } from "framer-motion";
import { Brain, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const SPECIALTIES = ["Account strategy and planning", "Deal acceleration tactics", "Objection handling", "Persona Insights", "Consultative selling", "Revenue generation strategies"];

export const AdvisorWelcomeModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div className="fixed inset-0 z-50 flex items-center justify-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <div className="absolute inset-0 bg-black/80" onClick={onClose} />
        <motion.div className="glass-card p-8 max-w-lg mx-4 relative z-10 holo-border" initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }}>
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors">
            <X className="h-5 w-5" />
          </button>

          <div className="mb-6">
            <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-ism-teal/20 to-ism-teal/10 flex items-center justify-center mx-auto mb-4 border border-ism-teal/20">
              <Brain className="h-10 w-10 text-ism-teal" />
            </div>
            <h2 className="text-2xl text-center mb-2"><span className="text-gray-200">Sales Strategy Advisor</span></h2>
            <p className="text-gray-400 text-center">Your AI expert using Forward Deployed Selling</p>
          </div>

          <div className="space-y-3 mb-6 text-gray-300">
            <p className="leading-relaxed"><span className="text-white">I specialize in:</span></p>
            <ul className="list-none space-y-2 pl-4">
              {SPECIALTIES.map((item, i) => (
                <motion.li key={item} className="flex items-center gap-2" initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.1 }}>
                  <div className="w-1.5 h-1.5 rounded-full bg-ism-teal" />
                  {item}
                </motion.li>
              ))}
            </ul>
            <p className="text-sm text-gray-500 pt-3">Ask me anything about your sales challenges, and I'll provide guidance rooted in proven methodologies.</p>
          </div>

          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <Button onClick={onClose} className="w-full bg-ism-teal hover:bg-ism-teal-light text-white font-semibold py-3 rounded-xl">
              Got it, let's start!
            </Button>
          </motion.div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
